<template>
  <div
    class="pa-2"
    style="
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 250px;
    "
  >
    <div class="answer-btn icon-align">
      <v-btn color="green" variant="text" style="width: 25px; height: 25px;" icon @click="answer">
        <v-icon color="white" size="x-small">mdi-phone</v-icon>
      </v-btn>
    </div>
    <div
      class="call-info-container"
      style="
        text-align: center;
        overflow: hidden;
        height: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
      "
    >
      <p class="caller-title" style="margin: 0; font-size: 14px; line-height: 1.2;">{{ inboundCallerDisplayTitle }}</p>
      <v-tooltip v-if="inboundCallRole" :text="`You are being requested to join this call as a ${inboundCallRole}`" location="bottom" v-model="showRoleTooltip" :open-on-hover="false">
        <template v-slot:activator="{ props }">
          <div v-bind="props" class="role-icon-container">
            <v-icon v-if="inboundCallRole === 'Supervisor'" size="x-small" color="primary">mdi-account-supervisor</v-icon>
            <v-icon v-else-if="inboundCallRole === 'Agent'" size="x-small" color="primary">mdi-account-plus</v-icon>
          </div>
        </template>
      </v-tooltip>
    </div>
    <div class="ignore-btn icon-align">
      <v-btn variant="text" style="width: 25px; height: 25px;" @click="ignore">
        <v-icon color="white" size="small">mdi-phone-hangup</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import PlivoService from "@/services/plivoService";
import { mapGetters } from "vuex";

export default {
  name: "IncomingCallDisplay",
  props: {
    inboundCallerDisplayTitle: String,
    inboundCallUUID: String,
    inboundCallRole: String,
  },
  computed: {
    ...mapGetters("plivo", ["getCurrConferenceName"]),
  },
  data() {
    return {
      showRoleTooltip: !!this.inboundCallRole,
    };
  },
  watch: {
    inboundCallRole: {
      immediate: true,
      handler(val) {
        this.showRoleTooltip = !!val;
      }
    }
  },
  methods: {
    async answer() {
      // check if the user is already in a call
      if (this.getCurrConferenceName) await PlivoService.transferUser();

      this.plivoBrowserSdk.client.answer(this.inboundCallUUID, "letring");
    },

    ignore() {
      if(this.inboundCallRole){
        this.plivoBrowserSdk.client.reject(this.inboundCallUUID);
      }
      // Ignoring the call and emitting an event to the 'CallBar' signaling that we have ignored the call.
      else{
        this.plivoBrowserSdk.client.ignore(this.inboundCallUUID);
      }
      this.$emit("incomingCallIgnored");
    },
  },
};
</script>

<style scoped>
.icon-align {
  display: flex;
  align-items: center;
  justify-content: center;
}

.call-info-container {
  min-width: 0;
  flex: 1;
  margin: 0 8px;
}

.caller-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.role-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
}

.answer-btn {
  background: green;
  width: 40px;
  height: 40px;
  position: relative;
  margin: 0 auto;
  border-radius: 100%;
  animation: answer-btn-animation 2s ease infinite;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
}
@keyframes answer-btn-animation {
  0% {
    transform: scale(1);
  }
  15% {
    box-shadow: 0 0 0 5px rgba(108, 173, 69, 0.4);
  }
  25% {
    box-shadow: 0 0 0 10px rgba(17, 194, 62, 0.4), 0 0 0 20px rgba(23, 173, 31, 0.2);
  }
  25% {
    box-shadow: 0 0 0 15px rgba(12, 235, 112, 0.4), 0 0 0 30px rgba(24, 168, 43, 0.2);
  }
}

.ignore-btn {
  background: #f8302c;
  width: 40px;
  height: 40px;
  position: relative;
  margin: 0 auto;
  border-radius: 100%;
  animation: ignore-btn-animation 2s ease infinite;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
}
@keyframes ignore-btn-animation {
  0% {
    transform: scale(1);
  }
  15% {
    box-shadow: 0 0 0 5px rgba(202, 28, 28, 0.4);
  }
  25% {
    box-shadow: 0 0 0 10px rgba(228, 19, 19, 0.4), 0 0 0 20px rgba(196, 33, 12, 0.2);
  }
  25% {
    box-shadow: 0 0 0 15px rgba(221, 111, 111, 0.295), 0 0 0 30px rgba(206, 136, 136, 0.644);
  }
}
</style>
